import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/SawitK.css";
import axios from "axios";

const KebunT = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const [penjualanList, setPenjualanList] = useState([]);
  const [tanggal, setTanggal] = useState("");

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/get_user_role",
          { withCredentials: true }
        );
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const fetchPengirimanHistory = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/riwayat",
          { withCredentials: true }
        );
        setPenjualanList(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchUserInfo();
    fetchPengirimanHistory();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleDetail = (id) => {
    navigate(`/KebunLD/${id}`);
  };

  // Helper Badge Status
  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    const badgeStyle = { padding: "6px 14px", fontSize: "0.8rem", fontWeight: "500" };

    if (s === "terkirim" || s.includes("diterima") || s.includes("selesai") || s.includes("sampai")) {
      return (
        <span className="badge bg-success text-white rounded-pill" style={badgeStyle}>
          Diterima
        </span>
      );
    }

    if (s === "pengiriman" || s.includes("dalam pengiriman") || s.includes("proses") || s.includes("jalan") || (s.includes("kirim") && !s.includes("terkirim"))) {
      return (
        <span className="badge bg-primary text-white rounded-pill" style={badgeStyle}>
          Dalam Pengiriman
        </span>
      );
    }

    if (s.includes("tunda") || s.includes("pending") || s.includes("antri")) {
      return (
        <span className="badge bg-warning text-dark rounded-pill" style={badgeStyle}>
          Tertunda
        </span>
      );
    }

    if (s.includes("batal") || s.includes("tolak") || s.includes("gagal")) {
      return (
        <span className="badge bg-danger text-white rounded-pill" style={badgeStyle}>
          Dibatalkan
        </span>
      );
    }

    return (
      <span className="badge bg-secondary text-white rounded-pill text-capitalize" style={badgeStyle}>
        {status || "-"}
      </span>
    );
  };

  const formatBerat = (val) => {
    if (!val || val === "N/A" || isNaN(Number(val))) {
      return <span className="text-muted">-</span>;
    }
    return <span>{Number(val).toLocaleString("id-ID")} Kg</span>;
  };

  return (
    <div className="d-flex flex-column">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span id="user-role">{userInfo.full_name} |</span>
          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex">
        {/* Sidebar */}
        <div className="sidebar p-3" id="sidebar">
          <p id="sidebar-title">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle">Telsa Super Apps</h6>
          <p id="sidebar-date">
            <img src="/static/schedule_11145854.png" alt="Date" />
            <span>{tanggal}</span>
          </p>
          <div className="list-group list-group-flush" id="sidebar-menu">
            <div
              id="sidebar-home"
              onClick={() => navigate("/kebun")}
              className={`list-group-item text-decoration-none ${
                location.pathname.startsWith("/kebun") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.startsWith("/kebun") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              id="sidebar-petani"
              onClick={() => navigate("/KebunP")}
              className={`list-group-item text-decoration-none ${
                location.pathname.toLowerCase().includes("kebunp") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.toLowerCase().includes("kebunp") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/Tanam.png" alt="Planting" /> Petani
            </div>
            <div
              id="sidebar-logistik"
              onClick={() => navigate("/kebunL")}
              className={`list-group-item text-decoration-none ${
                location.pathname.toLowerCase().includes("kebunl") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.toLowerCase().includes("kebunl") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Logistics" /> Logistik
            </div>
            <div
              id="sidebar-pabrik"
              onClick={() => navigate("/kebunpabrik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/kebunpabrik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/kebunpabrik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/factory.png" alt="Factory" /> Pabrik
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content" style={{ width: "100%" }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">Penjualan</h2>
            <button
              type="button"
              className="btn kembali-button"
              onClick={handleBack}
            >
              Kembali
            </button>
          </div>

          <div className="divider"></div>

          {/* Tabel Pengiriman Container */}
          <div className="table-container content-box">
            
            {/* Proteksi DataTables: Tabel hanya dirender jika data tersedia */}
            {penjualanList && penjualanList.length > 0 ? (
              <div className="table-responsive">
                <table 
                  className="table table-bordered table-hover align-middle mt-2 w-100" 
                >
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center">Tracking ID</th>
                      <th>Nama Petani</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Berat Awal</th>
                      <th className="text-center">Berat Akhir</th>
                      <th className="text-center">Tgl Kirim</th>
                      <th className="text-center">Tgl Diterima</th>
                      <th className="text-end">Total Biaya</th>
                      <th className="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {penjualanList.map((item, index) => (
                      <tr key={`penjualan-${item.tracking_id || index}`}>
                        <td className="text-center fw-bold text-secondary font-monospace text-nowrap">
                          {item.tracking_id || "-"}
                        </td>
                        <td className="fw-semibold text-dark text-capitalize text-nowrap">
                          {item.nama_petani || "-"}
                        </td>
                        <td className="text-center text-nowrap" style={{ minWidth: "160px" }}>
                          {getStatusBadge(item.status)}
                        </td>
                        <td className="text-center text-nowrap">
                          {formatBerat(item.berat_awal_sawit)}
                        </td>
                        <td className="text-center text-nowrap">
                          {formatBerat(item.berat_akhir_sawit)}
                        </td>
                        <td className="text-center text-muted text-nowrap">
                          {item.tanggal_pengiriman || "-"}
                        </td>
                        <td className="text-center text-muted text-nowrap">
                          {item.tanggal_diterima || "-"}
                        </td>
                        <td className="text-end fw-bold text-success text-nowrap">
                          {item.total_biaya && !isNaN(Number(item.total_biaya))
                            ? `Rp ${Number(item.total_biaya).toLocaleString("id-ID")}`
                            : "-"}
                        </td>
                        <td className="text-center text-nowrap">
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm rounded-pill px-3"
                            onClick={() => handleDetail(item.tracking_id)}
                          >
                            Detail
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-folder-open mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Transaksi</h5>
                <p className="mb-0">Belum ada riwayat transaksi penjualan.</p>
              </div>
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default KebunT;